"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = require("redux-saga/effects");
var authState_1 = require("../states/authState");
var authSelectors_1 = require("../selectors/authSelectors");
var authServices_1 = require("../services/authServices");
var settingsSelectors_1 = require("../selectors/settingsSelectors");
var i18n_1 = __importDefault(require("../i18n"));
var reportErrorsToInstrumentation_1 = __importStar(require("../helper/reportErrorsToInstrumentation"));
var consumerState_1 = require("../states/consumerState");
var ConsumptionsState_1 = require("../states/ConsumptionsState");
var ClientAccountsState_1 = require("../states/ClientAccountsState");
var accountState_1 = require("../states/accountState");
var deliveryPointState_1 = require("../states/deliveryPointState");
var billingAgreementState_1 = require("../states/billingAgreementState");
var invoiceState_1 = require("../states/invoiceState");
var paymentState_1 = require("../states/paymentState");
var productContractState_1 = require("../states/productContractState");
var utils_1 = require("../helper/utils");
var consumerSelector_1 = require("../selectors/consumerSelector");
var effectsHelper_1 = require("./effectsHelper");
var ClientAccount_1 = __importDefault(require("../models/ClientAccount"));
function resetAllData() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // reset all datas
            return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.reset())];
            case 1:
                // reset all datas
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(consumerState_1.consumerActions.reset())];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(ConsumptionsState_1.consumptionsActions.reset())];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.reset())];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(accountState_1.accountActions.reset())];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.reset())];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(deliveryPointState_1.deliveryPointActions.reset())];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(invoiceState_1.invoiceActions.reset())];
            case 8:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(productContractState_1.productContractActions.reset())];
            case 9:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(paymentState_1.paymentsActions.reset())];
            case 10:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.reset())];
            case 11:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function unsubscribeEffect(action) {
    var token, consumer, user, clientId, err_1, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 8, , 12]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('Missing token');
                return [4 /*yield*/, (0, effects_1.select)(consumerSelector_1.getConsumer)];
            case 2:
                consumer = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAuthenticatedUser)];
            case 3:
                user = _a.sent();
                if (!consumer && !user)
                    throw Error;
                clientId = consumer.clientId || user.clientId;
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.unsubscribeService, clientId, token)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.unsubscribeUserSuccess())];
            case 5:
                _a.sent();
                return [4 /*yield*/, resetAllData()];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 7:
                _a.sent();
                return [3 /*break*/, 12];
            case 8:
                err_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 9:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.unsubscribeUserFailure(errorMsg))];
            case 10:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, err_1, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, unsubscribeEffect.name))];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function loginEffect(action) {
    var signinFailure, user, getConsumerFailure, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // This login saga provide a context after getConsumerData
            // The loginSuccess trigger when we got the accessToken and the consumer data
            return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.signin({
                    email: action.payload.email,
                    password: action.payload.password,
                    captchaToken: action.payload.captchaToken
                }))];
            case 1:
                // This login saga provide a context after getConsumerData
                // The loginSuccess trigger when we got the accessToken and the consumer data
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 8, , 11]);
                return [4 /*yield*/, (0, effects_1.race)({
                        success: (0, effects_1.take)(authState_1.authActions.signinSuccess.type),
                        error: (0, effects_1.take)(authState_1.authActions.signinFailure.type)
                    })];
            case 3:
                signinFailure = (_a.sent()).signinFailure;
                if (signinFailure)
                    throw Error;
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAuthenticatedUser)];
            case 4:
                user = _a.sent();
                if (!user)
                    throw Error;
                return [4 /*yield*/, (0, effects_1.put)(consumerState_1.consumerActions.getConsumerData(user.clientId))];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.race)({
                        success: (0, effects_1.take)(consumerState_1.consumerActions.getConsumerSuccess.type),
                        error: (0, effects_1.take)(consumerState_1.consumerActions.getConsumerFailure.type)
                    })];
            case 6:
                getConsumerFailure = (_a.sent()).getConsumerFailure;
                if (getConsumerFailure)
                    throw Error;
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.loginSuccess(action.payload))];
            case 7:
                _a.sent();
                return [3 /*break*/, 11];
            case 8:
                err_2 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.loginFailure())];
            case 9:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, err_2, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, loginEffect.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
/**
 * @deprecated removed and replaced by signinEffect
 */
// worker Saga: will be fired on getToken actions
function getTokenEffect(action) {
    var authResponse, getConsumerFailure, e_1, language, errorMsg, payload, responseStatus, responseBody, error;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 5, , 20]);
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.getTokenService, action.payload.email, action.payload.password, action.payload.isRecaptchaV3, action.payload.captchaToken)];
            case 1:
                authResponse = _c.sent();
                return [4 /*yield*/, (0, effects_1.put)(consumerState_1.consumerActions.getConsumerData(authResponse.clientId, authResponse.token.access_token))];
            case 2:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.race)({
                        success: (0, effects_1.take)(consumerState_1.consumerActions.getConsumerSuccess.type),
                        error: (0, effects_1.take)(consumerState_1.consumerActions.getConsumerFailure.type)
                    })];
            case 3:
                getConsumerFailure = (_c.sent()).getConsumerFailure;
                if (getConsumerFailure)
                    throw Error;
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.getTokenSuccess(authResponse))];
            case 4:
                _c.sent();
                return [3 /*break*/, 20];
            case 5:
                e_1 = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_c.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                payload = {
                    email: action.payload.email,
                    password: action.payload.password
                };
                responseStatus = (_a = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _a === void 0 ? void 0 : _a.status;
                responseBody = (_b = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _b === void 0 ? void 0 : _b.data;
                if (!(responseStatus === 401)) return [3 /*break*/, 12];
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.wrongIdentifiers;
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.fetchIdentifiedUser(payload))];
            case 7:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.race)({
                        success: (0, effects_1.take)(authState_1.authActions.fetchIdentifiedUserSuccess.type),
                        error: (0, effects_1.take)(authState_1.authActions.fetchIdentifiedUserError.type)
                    })];
            case 8:
                error = (_c.sent()).error;
                if (!error) return [3 /*break*/, 10];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.getTokenFailure(errorMsg))];
            case 9:
                _c.sent();
                return [2 /*return*/];
            case 10: return [4 /*yield*/, (0, effects_1.cancel)()];
            case 11:
                _c.sent();
                return [2 /*return*/];
            case 12:
                if (!(responseStatus === 403 && responseBody)) return [3 /*break*/, 17];
                if (!(responseBody.code === 1)) return [3 /*break*/, 14];
                // Code d'erreur pour un recaptach invalid
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.getTokenFailure((0, i18n_1.default)(language).api.auth.errors.unsuccessfulAction, true))];
            case 13:
                // Code d'erreur pour un recaptach invalid
                _c.sent();
                return [3 /*break*/, 16];
            case 14:
                if (!(responseBody.code === 2)) return [3 /*break*/, 16];
                // Code d'erreur pour un contrat terminé
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.getTokenFailure((0, i18n_1.default)(language).api.auth.errors.contractTerminated))];
            case 15:
                // Code d'erreur pour un contrat terminé
                _c.sent();
                _c.label = 16;
            case 16: return [2 /*return*/];
            case 17: return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.getTokenFailure(errorMsg))];
            case 18:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_1, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getTokenEffect.name))];
            case 19:
                _c.sent();
                return [3 /*break*/, 20];
            case 20: return [2 /*return*/];
        }
    });
}
// worker Saga: will be fired on getAccessToken actions
function signinEffect(action) {
    var authResponse, e_2, language, errorMsg, responseStatus, responseBody, _a;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 3, , 18]);
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.getAccessTokenService, action.payload.email, action.payload.password, action.payload.isRecaptchaV3, action.payload.captchaToken)];
            case 1:
                authResponse = _d.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.signinSuccess(authResponse))];
            case 2:
                _d.sent();
                return [3 /*break*/, 18];
            case 3:
                e_2 = _d.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 4:
                language = (_d.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError || null;
                responseStatus = (_b = e_2 === null || e_2 === void 0 ? void 0 : e_2.response) === null || _b === void 0 ? void 0 : _b.status;
                responseBody = (_c = e_2 === null || e_2 === void 0 ? void 0 : e_2.response) === null || _c === void 0 ? void 0 : _c.data;
                _a = responseStatus;
                switch (_a) {
                    case 400: return [3 /*break*/, 5];
                    case 401: return [3 /*break*/, 7];
                    case 403: return [3 /*break*/, 8];
                    case 404: return [3 /*break*/, 9];
                    case 410: return [3 /*break*/, 10];
                    case 412: return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 5: 
            // Code d'erreur pour un recaptach invalid
            return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.signinFailure((0, i18n_1.default)(language).api.auth.errors
                    .unsuccessfulAction, responseStatus, true))];
            case 6:
                // Code d'erreur pour un recaptach invalid
                _d.sent();
                return [2 /*return*/];
            case 7:
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.wrongIdentifiers;
                return [3 /*break*/, 15];
            case 8:
                // Code d'erreur pour un blocage WAF
                errorMsg = (0, i18n_1.default)(language).common.wafBlockingError;
                return [3 /*break*/, 15];
            case 9:
                errorMsg = null;
                return [3 /*break*/, 15];
            case 10: 
            // Code d'erreur pour un contrat terminé
            return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.signinFailure((0, i18n_1.default)(language).api.auth.errors
                    .contractTerminated, responseStatus))];
            case 11:
                // Code d'erreur pour un contrat terminé
                _d.sent();
                return [2 /*return*/];
            case 12:
                errorMsg = null;
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.signinFailure(errorMsg, responseStatus, undefined, responseBody))];
            case 13:
                _d.sent();
                return [2 /*return*/];
            case 14: return [3 /*break*/, 15];
            case 15: return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.signinFailure(errorMsg, responseStatus))];
            case 16:
                _d.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_2, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, signinEffect.name))];
            case 17:
                _d.sent();
                return [3 /*break*/, 18];
            case 18: return [2 /*return*/];
        }
    });
}
function getUserLoginEffect(action) {
    var token, data, e_3, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('Missing token');
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.getUserLoginService, action.payload, token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.getUserLoginSuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4:
                e_3 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.getUserLoginFailure(errorMsg))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_3, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getUserLoginEffect.name))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
//tested
function getIdentifiedUserEffect(action) {
    var language, errorMsg, data, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_a.sent()).language;
                _a.label = 2;
            case 2:
                _a.trys.push([2, 7, , 10]);
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.getIdentifiedUserService, action.payload.email, action.payload.password)];
            case 3:
                data = _a.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.wrongIdentifiers;
                if (!!(data.resetPassword && data.active == 1)) return [3 /*break*/, 5];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.fetchIdentifiedUserError(errorMsg))];
            case 4:
                _a.sent();
                return [2 /*return*/];
            case 5: return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.fetchIdentifiedUserSuccess(data))];
            case 6:
                _a.sent();
                return [3 /*break*/, 10];
            case 7:
                e_4 = _a.sent();
                //TODO check if the current error is 404 or 500?
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.fetchIdentifiedUserError(errorMsg))];
            case 8:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_4, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getIdentifiedUserEffect.name))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function finalizeCreateAccountEffect(action) {
    var token, FFCreateAccountSaphir, version, password, error_1, language, errorMsg;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 5, , 9]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.isFeatureEnabled, 'Creation-Compte-Api-Saphir')];
            case 2:
                FFCreateAccountSaphir = _c.sent();
                version = 'v1';
                if (FFCreateAccountSaphir)
                    version = 'v2';
                password = action.payload;
                if (!token)
                    throw Error('no token provided');
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.finalizeCreateAccountService, token, password, version)];
            case 3:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.finalizeCreateAccountSuccess())];
            case 4:
                _c.sent();
                return [3 /*break*/, 9];
            case 5:
                error_1 = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_c.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                    errorMsg = (0, i18n_1.default)(language).CreateAccount.stepThreeInThree.expiredLink;
                }
                if (((_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.status) === 403) {
                    // Code d'erreur pour un blocage WAF
                    errorMsg = (0, i18n_1.default)(language).common.wafBlockingError;
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.finalizeCreateAccountFailure(errorMsg))];
            case 7:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, error_1, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, finalizeCreateAccountEffect.name))];
            case 8:
                _c.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
//tested
function initializeUserEffect(action) {
    var tempEmail, e_5, language, errorMsg;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getTempEmail)];
            case 1:
                tempEmail = _d.sent();
                _d.label = 2;
            case 2:
                _d.trys.push([2, 6, , 10]);
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.initializeUserService, tempEmail, action.payload.currentPassword, action.payload.newPassword, action.payload.origin)];
            case 3:
                _d.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.initializeUserSuccess())];
            case 4:
                _d.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.signin({
                        email: tempEmail,
                        password: action.payload.newPassword
                    }))];
            case 5:
                _d.sent();
                return [3 /*break*/, 10];
            case 6:
                e_5 = _d.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 7:
                language = (_d.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = e_5 === null || e_5 === void 0 ? void 0 : e_5.response) === null || _a === void 0 ? void 0 : _a.status) === 400) {
                    // new password match current password
                    errorMsg = (0, i18n_1.default)(language).api.auth.errors.identicPassword;
                }
                if (((_b = e_5 === null || e_5 === void 0 ? void 0 : e_5.response) === null || _b === void 0 ? void 0 : _b.status) === 401) {
                    // wrong current password old user
                    errorMsg = (0, i18n_1.default)(language).api.auth.errors.wrongPassword;
                }
                if (((_c = e_5 === null || e_5 === void 0 ? void 0 : e_5.response) === null || _c === void 0 ? void 0 : _c.status) === 404) {
                    // wrong current password new user
                    errorMsg = (0, i18n_1.default)(language).forms.errors.wrongCurrentPassword;
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.initializeUserError(errorMsg))];
            case 8:
                _d.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_5, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, initializeUserEffect.name))];
            case 9:
                _d.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function resetPasswordEffect(action) {
    var language, e_6, errorMsg;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_c.sent()).language;
                _c.label = 2;
            case 2:
                _c.trys.push([2, 5, , 8]);
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.resetPasswordService, action.payload.tokenEmail, action.payload.newPassword)];
            case 3:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.resetPasswordSuccess())];
            case 4:
                _c.sent();
                return [3 /*break*/, 8];
            case 5:
                e_6 = _c.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = e_6 === null || e_6 === void 0 ? void 0 : e_6.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                    errorMsg = (0, i18n_1.default)(language).api.auth.errors.wrongIdentifiers;
                }
                if (((_b = e_6 === null || e_6 === void 0 ? void 0 : e_6.response) === null || _b === void 0 ? void 0 : _b.status) === 403) {
                    // Code d'erreur pour un blocage WAF
                    errorMsg = (0, i18n_1.default)(language).common.wafBlockingError;
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.resetPasswordError(errorMsg))];
            case 6:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_6, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, resetPasswordEffect.name))];
            case 7:
                _c.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function sendEmailEffect(action) {
    var language, createUserCaptchaToken, data, e_7, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_a.sent()).language;
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 9]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getCreateAccountData)];
            case 3:
                createUserCaptchaToken = (_a.sent()).createUserCaptchaToken;
                if (!createUserCaptchaToken)
                    throw Error('Missing captcha token');
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.sendEmailService, action.payload, createUserCaptchaToken)];
            case 4:
                data = _a.sent();
                if (data === 'UnsubscribeUserWithForgetPasswordOk') {
                    throw 'UnsubscribeUserWithForgetPassword';
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.sendEmailSuccess())];
            case 5:
                _a.sent();
                return [3 /*break*/, 9];
            case 6:
                e_7 = _a.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (e_7 === 'UnsubscribeUserWithForgetPassword') {
                    errorMsg = (0, i18n_1.default)(language).api.auth.errors.contractTerminated;
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.sendEmailError(errorMsg))];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_7, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, sendEmailEffect.name))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getAuthenticatedUserEffect() {
    var language, token, user, e_8, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_a.sent()).language;
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 9]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 3:
                token = _a.sent();
                if (!token)
                    throw Error('Missing token');
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.getAuthenticatedUserService, token)];
            case 4:
                user = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.getAuthentifiedUserSuccess(user))];
            case 5:
                _a.sent();
                return [3 /*break*/, 9];
            case 6:
                e_8 = _a.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.getAuthentifiedUserFailure(errorMsg))];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_8, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getAuthenticatedUserEffect.name))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function checkTokenValidityEffect(action) {
    var language, e_9, errorMsg, isExpired_;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_c.sent()).language;
                _c.label = 2;
            case 2:
                _c.trys.push([2, 5, , 8]);
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.checkTokenValidityService, action.payload)];
            case 3:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.checkTokenValiditySuccess())];
            case 4:
                _c.sent();
                return [3 /*break*/, 8];
            case 5:
                e_9 = _c.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                isExpired_ = false;
                if (e_9['response'] && e_9['response']['status'] === 404) {
                    errorMsg = (0, i18n_1.default)(language).forgetPasswordScreen.sessionError;
                    isExpired_ = true;
                }
                if (((_a = e_9 === null || e_9 === void 0 ? void 0 : e_9.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                    errorMsg = (0, i18n_1.default)(language).api.auth.errors.wrongIdentifiers;
                }
                if (((_b = e_9 === null || e_9 === void 0 ? void 0 : e_9.response) === null || _b === void 0 ? void 0 : _b.status) === 403) {
                    // Code d'erreur pour un blocage WAF
                    errorMsg = (0, i18n_1.default)(language).common.wafBlockingError;
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.checkTokenValidityError(errorMsg, isExpired_))];
            case 6:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_9, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, checkTokenValidityEffect.name))];
            case 7:
                _c.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function checkUpdateEmailTokenValidityEffect(action) {
    var language, e_10, errorMsg, isExpired_;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_d.sent()).language;
                _d.label = 2;
            case 2:
                _d.trys.push([2, 5, , 8]);
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.checkUpdateEmailTokenValidityService, action.payload)];
            case 3:
                _d.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.checkUpdateEmailTokenValiditySuccess())];
            case 4:
                _d.sent();
                return [3 /*break*/, 8];
            case 5:
                e_10 = _d.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                isExpired_ = false;
                if (((_a = e_10 === null || e_10 === void 0 ? void 0 : e_10.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                    errorMsg = (0, i18n_1.default)(language).api.auth.errors.invalidToken;
                    isExpired_ = true;
                }
                if (((_b = e_10 === null || e_10 === void 0 ? void 0 : e_10.response) === null || _b === void 0 ? void 0 : _b.status) === 401) {
                    errorMsg = (0, i18n_1.default)(language).api.auth.errors.wrongIdentifiers;
                }
                if (((_c = e_10 === null || e_10 === void 0 ? void 0 : e_10.response) === null || _c === void 0 ? void 0 : _c.status) === 403) {
                    // Code d'erreur pour un blocage WAF
                    errorMsg = (0, i18n_1.default)(language).common.wafBlockingError;
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.checkUpdateEmailTokenValidityError(errorMsg, isExpired_))];
            case 6:
                _d.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_10, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, checkUpdateEmailTokenValidityEffect.name))];
            case 7:
                _d.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function logoutEffect(action) {
    var language, refreshToken, token, isTokenExpired, e_11, errorMsg;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_b.sent()).language;
                _b.label = 2;
            case 2:
                _b.trys.push([2, 10, , 13]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getRefreshToken)];
            case 3:
                refreshToken = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 4:
                token = _b.sent();
                if (!token)
                    throw Error('no token provided');
                if (!refreshToken)
                    throw Error('no token provided');
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.isExpired)];
            case 5:
                isTokenExpired = _b.sent();
                if (!!isTokenExpired) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.invalidateMulesoftCache, token)];
            case 6:
                _b.sent();
                _b.label = 7;
            case 7: return [4 /*yield*/, (0, effects_1.call)(authServices_1.removeToken, refreshToken)];
            case 8:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logoutSuccess(isTokenExpired ? 'tokenExpired' : undefined))];
            case 9:
                _b.sent();
                return [3 /*break*/, 13];
            case 10:
                e_11 = _b.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = e_11 === null || e_11 === void 0 ? void 0 : e_11.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                    errorMsg = (0, i18n_1.default)(language).api.auth.errors.wrongIdentifiers;
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logoutFailure(errorMsg, (0, utils_1.buildTechnicalErrorMessage)(e_11)))];
            case 11:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_11, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, logoutEffect.name))];
            case 12:
                _b.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
function logoutV2Effect(action) {
    var language, refreshToken, token, isTokenExpired, e_12, errorMsg;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_c.sent()).language;
                _c.label = 2;
            case 2:
                _c.trys.push([2, 8, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getRefreshToken)];
            case 3:
                refreshToken = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 4:
                token = _c.sent();
                if (!token)
                    throw Error('no token provided');
                if (!refreshToken)
                    throw Error('no refresh Token provided');
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.isExpired)];
            case 5:
                isTokenExpired = _c.sent();
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.logoutV2Service, refreshToken, token, action.payload)];
            case 6:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logoutSuccessV2(isTokenExpired ? 'tokenExpired' : undefined))];
            case 7:
                _c.sent();
                return [3 /*break*/, 11];
            case 8:
                e_12 = _c.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = e_12 === null || e_12 === void 0 ? void 0 : e_12.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                    errorMsg = (0, i18n_1.default)(language).api.auth.errors.wrongIdentifiers;
                }
                if (((_b = e_12 === null || e_12 === void 0 ? void 0 : e_12.response) === null || _b === void 0 ? void 0 : _b.status) === 403) {
                    // Code d'erreur pour un blocage WAF
                    errorMsg = (0, i18n_1.default)(language).common.wafBlockingError;
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logoutFailureV2(errorMsg, (0, utils_1.buildTechnicalErrorMessage)(e_12)))];
            case 9:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_12, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, logoutV2Effect.name))];
            case 10:
                _c.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function sendNewCreatedUserDataEffectOld(action) {
    var language, createUserCaptchaToken, data, error_2, errorMsg;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_e.sent()).language;
                _e.label = 2;
            case 2:
                _e.trys.push([2, 7, , 10]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getCreateAccountData)];
            case 3:
                createUserCaptchaToken = (_e.sent()).createUserCaptchaToken;
                if (!createUserCaptchaToken)
                    throw Error('Missing captcha token');
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.getNewIdentifiedUserDataServiceOld, action.payload.userReferenceId, action.payload.userName, createUserCaptchaToken)];
            case 4:
                data = _e.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.checkNewIdentifiedUserSuccessOld(data))];
            case 5:
                _e.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.setCreateAccountInformation({
                        userReference: action.payload.userReferenceId,
                        userName: action.payload.userName,
                        userFirstName: data.firstName
                    }))];
            case 6:
                _e.sent();
                return [3 /*break*/, 10];
            case 7:
                error_2 = _e.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                    errorMsg = (0, i18n_1.default)(language).common.identificationDenied;
                }
                if (((_b = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _b === void 0 ? void 0 : _b.status) === 409) {
                    errorMsg =
                        (0, i18n_1.default)(language).CreateAccount.stepOneInThree.referenceUsed;
                }
                if (((_c = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _c === void 0 ? void 0 : _c.status) === 412) {
                    errorMsg =
                        (0, i18n_1.default)(language).CreateAccount.stepOneInThree.subscriptionPending;
                }
                if (((_d = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _d === void 0 ? void 0 : _d.status) === 403) {
                    errorMsg =
                        (0, i18n_1.default)(language).CreateAccount.stepOneInThree
                            .subscriptionUnpermited;
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.checkNewIdentifiedUserFailureOld(errorMsg))];
            case 8:
                _e.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, error_2, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, sendNewCreatedUserDataEffectOld.name))];
            case 9:
                _e.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function sendNewCreatedUserDataEffect(action) {
    var language, createUserCaptchaToken, restrictedClientData, error_3, errorMsg;
    var _a, _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_g.sent()).language;
                _g.label = 2;
            case 2:
                _g.trys.push([2, 6, , 9]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getCreateAccountData)];
            case 3:
                createUserCaptchaToken = (_g.sent()).createUserCaptchaToken;
                if (!createUserCaptchaToken)
                    throw Error('Missing captcha token');
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.getNewIdentifiedUserDataService, action.payload.userReferenceId, action.payload.userName, createUserCaptchaToken)];
            case 4:
                restrictedClientData = _g.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.checkNewIdentifiedUserSuccess(restrictedClientData))];
            case 5:
                _g.sent();
                return [3 /*break*/, 9];
            case 6:
                error_3 = _g.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _a === void 0 ? void 0 : _a.status) === 403) {
                    // Code d'erreur pour un blocage WAF
                    errorMsg = (0, i18n_1.default)(language).common.wafBlockingError;
                }
                if (((_b = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _b === void 0 ? void 0 : _b.status) === 404) {
                    errorMsg = (0, effectsHelper_1.returnErrorMessage)((_c = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _c === void 0 ? void 0 : _c.data, (0, i18n_1.default)(language).common.wrongStatusAtCreation, (0, i18n_1.default)(language).common.identificationDenied, 'Found with unexpected status');
                }
                if (((_d = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _d === void 0 ? void 0 : _d.status) === 409) {
                    errorMsg =
                        (0, i18n_1.default)(language).CreateAccount.stepOneInThree.referenceUsed;
                }
                if (((_e = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _e === void 0 ? void 0 : _e.status) === 412) {
                    errorMsg =
                        (0, i18n_1.default)(language).CreateAccount.stepOneInThree.subscriptionPending;
                }
                if (((_f = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _f === void 0 ? void 0 : _f.status) === 422) {
                    errorMsg =
                        (0, i18n_1.default)(language).CreateAccount.stepOneInThree
                            .subscriptionUnpermited;
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.checkNewIdentifiedUserFailure(errorMsg))];
            case 7:
                _g.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, error_3, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, sendNewCreatedUserDataEffect.name))];
            case 8:
                _g.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function checkAndGetContractUserEffect(action) {
    var language, createUserCaptchaToken, data, clientAccounts, error_4, errorMsg;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_d.sent()).language;
                _d.label = 2;
            case 2:
                _d.trys.push([2, 6, , 9]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getCreateAccountData)];
            case 3:
                createUserCaptchaToken = (_d.sent()).createUserCaptchaToken;
                if (!createUserCaptchaToken)
                    throw Error('Missing captcha token');
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.checkAndGetContractUserService, action.payload.clientReference, action.payload.name, createUserCaptchaToken)];
            case 4:
                data = _d.sent();
                clientAccounts = data === null || data === void 0 ? void 0 : data.map(function (c) { return new ClientAccount_1.default(c); });
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.checkAndGetContractUserSuccess(clientAccounts))];
            case 5:
                _d.sent();
                return [3 /*break*/, 9];
            case 6:
                error_4 = _d.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = error_4 === null || error_4 === void 0 ? void 0 : error_4.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                    errorMsg = (0, effectsHelper_1.returnErrorMessage)((_b = error_4 === null || error_4 === void 0 ? void 0 : error_4.response) === null || _b === void 0 ? void 0 : _b.data, (0, i18n_1.default)(language).common.wrongStatusAtCreation, (0, i18n_1.default)(language).common.identificationDenied, 'Found with unexpected status');
                }
                else if (((_c = error_4 === null || error_4 === void 0 ? void 0 : error_4.response) === null || _c === void 0 ? void 0 : _c.status) === 444) {
                    errorMsg = (0, i18n_1.default)(language).clientIdentity.alreadyCanceled;
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.checkAndGetContractUserFailure(errorMsg))];
            case 7:
                _d.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, error_4, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, sendNewCreatedUserDataEffect.name))];
            case 8:
                _d.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function createUserAccountEffect(action) {
    var language, _a, userName, userReference, createUserCaptchaToken, FFCreateAccountSaphir, version, error_5, errorMsg;
    var _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_f.sent()).language;
                _f.label = 2;
            case 2:
                _f.trys.push([2, 7, , 10]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getCreateAccountData)];
            case 3:
                _a = _f.sent(), userName = _a.userName, userReference = _a.userReference, createUserCaptchaToken = _a.createUserCaptchaToken;
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.isFeatureEnabled, 'Creation-Compte-Api-Saphir')];
            case 4:
                FFCreateAccountSaphir = _f.sent();
                version = 'v1';
                if (FFCreateAccountSaphir)
                    version = 'v2.1';
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.createNewUserAccount, userReference, userName, action.payload.userEmail, action.payload.acceptSaurContact, createUserCaptchaToken, version)];
            case 5:
                _f.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.createUserAccountSuccess())];
            case 6:
                _f.sent();
                return [3 /*break*/, 10];
            case 7:
                error_5 = _f.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_b = error_5 === null || error_5 === void 0 ? void 0 : error_5.response) === null || _b === void 0 ? void 0 : _b.status) === 403) {
                    // Code d'erreur pour un blocage WAF
                    errorMsg = (0, i18n_1.default)(language).common.wafBlockingError;
                }
                if (((_c = error_5 === null || error_5 === void 0 ? void 0 : error_5.response) === null || _c === void 0 ? void 0 : _c.status) === 409) {
                    errorMsg = (0, effectsHelper_1.returnErrorMessage)((_d = error_5 === null || error_5 === void 0 ? void 0 : error_5.response) === null || _d === void 0 ? void 0 : _d.data, (0, i18n_1.default)(language).CreateAccount.stepTwoInThree
                        .inscriptionNotFinalizedError, (0, i18n_1.default)(language).CreateAccount.stepTwoInThree.emailUsedError, 'UserSubscriptionRequestInProgressFound');
                }
                if (((_e = error_5 === null || error_5 === void 0 ? void 0 : error_5.response) === null || _e === void 0 ? void 0 : _e.status) === 412) {
                    errorMsg =
                        (0, i18n_1.default)(language).CreateAccount.stepOneInThree.subscriptionPending;
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.createUserAccountFailure(errorMsg))];
            case 8:
                _f.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, error_5, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, createUserAccountEffect.name))];
            case 9:
                _f.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function resendSubscriptionMailEffect() {
    var language, _a, userName, userReference, userEmail, acceptSaurContact, FFCreateAccountSaphir, version, error_6, errorMsg;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_b.sent()).language;
                _b.label = 2;
            case 2:
                _b.trys.push([2, 7, , 10]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getCreateAccountData)];
            case 3:
                _a = _b.sent(), userName = _a.userName, userReference = _a.userReference, userEmail = _a.userEmail, acceptSaurContact = _a.acceptSaurContact;
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.isFeatureEnabled, 'Creation-Compte-Api-Saphir')];
            case 4:
                FFCreateAccountSaphir = _b.sent();
                version = 'v1';
                if (FFCreateAccountSaphir)
                    version = 'v2';
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.resendSubscriptionMail, userReference, userName, userEmail, acceptSaurContact, version)];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.resendSubscriptionDemandSuccess())];
            case 6:
                _b.sent();
                return [3 /*break*/, 10];
            case 7:
                error_6 = _b.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.resendSubscriptionDemandFailure(errorMsg))];
            case 8:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, error_6, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, resendSubscriptionMailEffect.name))];
            case 9:
                _b.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function updateEmailFirstStepEffect(action) {
    var language, token, error_7, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_a.sent()).language;
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 9]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 3:
                token = _a.sent();
                if (!token)
                    throw Error('Missing token');
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.updateEmailFirstStepService, token, action.payload.currentEmail, action.payload.newEmail)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.updateEmailFirstStepSuccess())];
            case 5:
                _a.sent();
                return [3 /*break*/, 9];
            case 6:
                error_7 = _a.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.updateEmailFirstStepError(errorMsg))];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, error_7, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, updateEmailFirstStepEffect.name))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function updateUserEmailEffect(action) {
    var createUserCaptchaToken, language, payload, e_13, errorMsg;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getCreateAccountData)];
            case 1:
                createUserCaptchaToken = (_c.sent()).createUserCaptchaToken;
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 2:
                language = (_c.sent()).language;
                payload = __assign(__assign({}, action.payload), { captchaToken: createUserCaptchaToken });
                _c.label = 3;
            case 3:
                _c.trys.push([3, 6, , 9]);
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.updateUserEmailService, payload)];
            case 4:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.updateUserEmailSuccess())];
            case 5:
                _c.sent();
                return [3 /*break*/, 9];
            case 6:
                e_13 = _c.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = e_13 === null || e_13 === void 0 ? void 0 : e_13.response) === null || _a === void 0 ? void 0 : _a.status) === 409) {
                    errorMsg =
                        (0, i18n_1.default)(language).CreateAccount.stepOneInThree.referenceUsed;
                }
                if (((_b = e_13 === null || e_13 === void 0 ? void 0 : e_13.response) === null || _b === void 0 ? void 0 : _b.status) === 404) {
                    errorMsg = (0, i18n_1.default)(language).common.identificationDenied;
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.updateUserEmailFailure(errorMsg))];
            case 7:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_13, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, updateUserEmailEffect.name))];
            case 8:
                _c.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function checkUserEmailEffect(action) {
    var language, createUserCaptchaToken, payload, e_14, errorMsg;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_c.sent()).language;
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getCreateAccountData)];
            case 2:
                createUserCaptchaToken = (_c.sent()).createUserCaptchaToken;
                payload = __assign(__assign({}, action.payload), { captchaToken: createUserCaptchaToken });
                _c.label = 3;
            case 3:
                _c.trys.push([3, 6, , 9]);
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.checkUserWithBillingOrIban, payload)];
            case 4:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.checkUserEmailSuccess())];
            case 5:
                _c.sent();
                return [3 /*break*/, 9];
            case 6:
                e_14 = _c.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = e_14 === null || e_14 === void 0 ? void 0 : e_14.response) === null || _a === void 0 ? void 0 : _a.status) === 409) {
                    errorMsg =
                        (0, i18n_1.default)(language).CreateAccount.stepOneInThree.referenceUsed;
                }
                if (((_b = e_14 === null || e_14 === void 0 ? void 0 : e_14.response) === null || _b === void 0 ? void 0 : _b.status) === 404) {
                    errorMsg = (0, i18n_1.default)(language).common.identificationDenied;
                }
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.checkUserEmailFailure(errorMsg))];
            case 7:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_14, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, checkUserEmailEffect.name))];
            case 8:
                _c.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function updateEmailAndNewsLetterFirstStepEffect(action) {
    var language, token, error_8, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 1:
                language = (_a.sent()).language;
                _a.label = 2;
            case 2:
                _a.trys.push([2, 8, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 3:
                token = _a.sent();
                if (!token)
                    throw Error('Missing token');
                return [4 /*yield*/, (0, effects_1.call)(authServices_1.updateEmailAndNewsLetterFirstStepService, token, action.payload.currentEmail, action.payload.newEmail, action.payload.contactByEmail)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.updateEmailAndNewsLetterFirstStepSuccess())];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(consumerState_1.consumerActions.reset())];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(consumerState_1.consumerActions.getConsumerData(action.payload.clientId))];
            case 7:
                _a.sent();
                return [3 /*break*/, 11];
            case 8:
                error_8 = _a.sent();
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.updateEmailAndNewsLetterFirstStepError(errorMsg))];
            case 9:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, error_8, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, updateEmailAndNewsLetterFirstStepEffect.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function authEffects() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.resetPassword.type, resetPasswordEffect)];
            case 1:
                _a.sent();
                //TO DO check if used by other apps and then remove this line
                //remove getToken is not used
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.getToken.type, getTokenEffect)];
            case 2:
                //TO DO check if used by other apps and then remove this line
                //remove getToken is not used
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.signin.type, signinEffect)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.fetchIdentifiedUser.type, getIdentifiedUserEffect)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.getUserLogin.type, getUserLoginEffect)];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.initializeUser.type, initializeUserEffect)];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.sendEmail.type, sendEmailEffect)];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.checkTokenValidity.type, checkTokenValidityEffect)];
            case 8:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.getAuthentifiedUser.type, getAuthenticatedUserEffect)];
            case 9:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.finalizeCreateAccount.type, finalizeCreateAccountEffect)];
            case 10:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.resendSubscriptionDemand.type, resendSubscriptionMailEffect)];
            case 11:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.logout.type, logoutEffect)];
            case 12:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.createUserAccount.type, createUserAccountEffect)];
            case 13:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.checkNewIdentifiedUser.type, sendNewCreatedUserDataEffect)];
            case 14:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.checkNewIdentifiedUserOld.type, sendNewCreatedUserDataEffectOld)];
            case 15:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.checkAndGetContractUser.type, checkAndGetContractUserEffect)];
            case 16:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.updateEmailAndNewsLetterFirstStep.type, updateEmailAndNewsLetterFirstStepEffect)];
            case 17:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.login.type, loginEffect)];
            case 18:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.updateEmailFirstStep.type, updateEmailFirstStepEffect)];
            case 19:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.checkUpdateEmailTokenValidity.type, checkUpdateEmailTokenValidityEffect)];
            case 20:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.unsubscribeUser.type, unsubscribeEffect)];
            case 21:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.logoutSuccess.type, resetAllData)];
            case 22:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.updateUserEmail.type, updateUserEmailEffect)];
            case 23:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.checkUserEmail.type, checkUserEmailEffect)];
            case 24:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(authState_1.authActions.logoutV2.type, logoutV2Effect)];
            case 25:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.default = authEffects;
